import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0020_HPMU_CAN01 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0020_HPMU_CAN01',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureSensor',
              isRead: 'true',
              interval: '268',
              texttableentry: 'FlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReturnTemperatureSensor',
              isRead: 'true',
              interval: '269',
              texttableentry: 'ReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterFlowSensor',
              isRead: 'true',
              interval: '270',
              texttableentry: 'WaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSensor',
              isRead: 'true',
              interval: '271',
              texttableentry: 'DomesticHotWaterSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSensor',
              isRead: 'true',
              interval: '272',
              texttableentry: 'DomesticHotWaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRoofTemperatureSensor',
              isRead: 'true',
              interval: '273',
              texttableentry: 'SolarRoofTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensor',
              isRead: 'true',
              interval: '274',
              texttableentry: 'OutsideTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarBottomTemperatureSensor',
              isRead: 'true',
              interval: '275',
              texttableentry: 'SolarBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarTopTemperatureSensor',
              isRead: 'true',
              interval: '276',
              texttableentry: 'SolarTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidTemperatureSensor',
              isRead: 'true',
              interval: '279',
              texttableentry: 'BufferMidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferTopTemperatureSensor',
              isRead: 'true',
              interval: '281',
              texttableentry: 'BufferTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorTemperatureSensor',
              isRead: 'true',
              interval: '282',
              texttableentry: 'HydraulicSeparatorTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorReturnTemperatureSensor',
              isRead: 'true',
              interval: '283',
              texttableentry: 'HydraulicSeparatorReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '284',
              texttableentry: 'MixerOneCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '285',
              texttableentry: 'MixerOneCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '286',
              texttableentry: 'MixerTwoCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '287',
              texttableentry: 'MixerTwoCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '288',
              texttableentry: 'MixerThreeCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '289',
              texttableentry: 'MixerThreeCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '290',
              texttableentry: 'MixerFourCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitReturnTemperatureSensor',
              isRead: 'true',
              interval: '291',
              texttableentry: 'MixerFourCircuitReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureSensor',
              isRead: 'true',
              interval: '318',
              texttableentry: 'WaterPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '320',
              texttableentry: 'PrimaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletTemperatureSensor',
              isRead: 'true',
              interval: '321',
              texttableentry: 'CompressorInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorInletPressureSensor',
              isRead: 'true',
              interval: '322',
              texttableentry: 'CompressorInletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionTemperatureSensor',
              isRead: 'true',
              interval: '323',
              texttableentry: 'EnhancedVapourInjectionTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletTemperatureSensor',
              isRead: 'true',
              interval: '324',
              texttableentry: 'CompressorOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOutletPressureSensor',
              isRead: 'true',
              interval: '325',
              texttableentry: 'CompressorOutletPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '334',
              texttableentry: 'MixerOneCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '335',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '336',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '337',
              texttableentry: 'MixerFourCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleBaseHeater',
              isRead: 'true',
              interval: '354',
              texttableentry: 'PrimaryHeatExchangerBaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '355',
              texttableentry: 'SecondaryHeatExchangerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOutletSensor',
              isRead: 'true',
              interval: '360',
              texttableentry: 'DomesticHotWaterOutletSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyTemperatureLimiterOneSwitch',
              isRead: 'true',
              interval: '362',
              texttableentry: 'SafetyTemperatureLimiterOneSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPump',
              isRead: 'true',
              interval: '381',
              texttableentry: 'CentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveTargetPositionPercent',
              isRead: 'true',
              interval: '384',
              texttableentry: 'DiverterValveTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveCurrentPositionPercent',
              isRead: 'true',
              interval: '385',
              texttableentry: 'DiverterValveCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '388',
              texttableentry: 'ElectronicExpansionValveOneTargetPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '389',
              texttableentry: 'ElectronicExpansionValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '390',
              texttableentry: 'ElectronicExpansionValveTwoTargetPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicExpansionValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '391',
              texttableentry: 'ElectronicExpansionValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '396',
              texttableentry: 'DomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPump',
              isRead: 'true',
              interval: '401',
              texttableentry: 'MixerOneCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPump',
              isRead: 'true',
              interval: '402',
              texttableentry: 'MixerTwoCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPump',
              isRead: 'true',
              interval: '403',
              texttableentry: 'MixerThreeCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPump',
              isRead: 'true',
              interval: '404',
              texttableentry: 'MixerFourCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPump',
              isRead: 'true',
              interval: '417',
              texttableentry: 'SolarCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '424',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '426',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '428',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '430',
              texttableentry: 'MixerFourCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpStatistical',
              isRead: 'true',
              interval: '457',
              texttableentry: 'CentralHeatingPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpStatistical',
              isRead: 'true',
              interval: '459',
              texttableentry: 'MixerOneCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpStatistical',
              isRead: 'true',
              interval: '460',
              texttableentry: 'MixerTwoCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpStatistical',
              isRead: 'true',
              interval: '461',
              texttableentry: 'MixerThreeCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpStatistical',
              isRead: 'true',
              interval: '462',
              texttableentry: 'MixerFourCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '475',
              texttableentry: 'MixerOneCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '476',
              texttableentry: 'MixerTwoCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '477',
              texttableentry: 'MixerThreeCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '478',
              texttableentry: 'MixerFourCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPump',
              isRead: 'true',
              interval: '491',
              texttableentry: 'DomesticHotWaterCirculationPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpDemand',
              isRead: 'true',
              interval: '496',
              texttableentry: 'DomesticHotWaterCirculationPumpDemand',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpMode',
              isRead: 'true',
              interval: '497',
              texttableentry: 'DomesticHotWaterCirculationPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatDemandExternalAc',
              isRead: 'true',
              interval: '500',
              texttableentry: 'CentralHeatDemandExternalAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ScaldProtection',
              isRead: 'true',
              interval: '503',
              texttableentry: 'ScaldProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSetpointMetaData',
              isRead: 'true',
              interval: '504',
              texttableentry: 'DomesticHotWaterSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinatedOffset',
              isRead: 'true',
              interval: '508',
              texttableentry: 'UniversalTimeCoordinatedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhase',
              isRead: 'true',
              interval: '511',
              texttableentry: 'HolidayPhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhase',
              isRead: 'true',
              interval: '512',
              texttableentry: 'HolidayAtHomePhase',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitOne',
              isRead: 'true',
              interval: '513',
              texttableentry: 'HolidayPhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitOne',
              isRead: 'true',
              interval: '514',
              texttableentry: 'HolidayAtHomePhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTwo',
              isRead: 'true',
              interval: '515',
              texttableentry: 'HolidayPhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTwo',
              isRead: 'true',
              interval: '516',
              texttableentry: 'HolidayAtHomePhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitThree',
              isRead: 'true',
              interval: '517',
              texttableentry: 'HolidayPhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitThree',
              isRead: 'true',
              interval: '518',
              texttableentry: 'HolidayAtHomePhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFour',
              isRead: 'true',
              interval: '519',
              texttableentry: 'HolidayPhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFour',
              isRead: 'true',
              interval: '520',
              texttableentry: 'HolidayAtHomePhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpoint',
              isRead: 'true',
              interval: '524',
              texttableentry: 'ModulationTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalModulationSetpoint',
              isRead: 'true',
              interval: '525',
              texttableentry: 'ExternalModulationSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValue',
              isRead: 'true',
              interval: '526',
              texttableentry: 'ModulationCurrentValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HumiditySensor',
              isRead: 'true',
              interval: '529',
              texttableentry: 'HumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOperationState',
              isRead: 'true',
              interval: '531',
              texttableentry: 'DomesticHotWaterOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpPostRunTime',
              isRead: 'true',
              interval: '534',
              texttableentry: 'DomesticHotWaterPumpPostRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitTargetOperationMode',
              isRead: 'true',
              interval: '537',
              texttableentry: 'ExternalMixerOneCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTargetOperationMode',
              isRead: 'true',
              interval: '538',
              texttableentry: 'ExternalDomesticHotWaterTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SmartGridReadyConsolidator',
              isRead: 'true',
              interval: '543',
              texttableentry: 'SmartGridReadyConsolidator',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeating',
              isRead: 'true',
              interval: '548',
              texttableentry: 'EnergyConsumptionCentralHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '565',
              texttableentry: 'EnergyConsumptionDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCooling',
              isRead: 'true',
              interval: '566',
              texttableentry: 'EnergyConsumptionCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerOnCounter',
              isRead: 'true',
              interval: '582',
              texttableentry: 'PowerOnCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticServiceConnectionStatus',
              isRead: 'true',
              interval: '620',
              texttableentry: 'DiagnosticServiceConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ObjectContactDetails',
              isRead: 'true',
              interval: '621',
              texttableentry: 'ObjectContactDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetails',
              isRead: 'true',
              interval: '622',
              texttableentry: 'CustomerDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TechnicalSupport',
              isRead: 'true',
              interval: '624',
              texttableentry: 'TechnicalSupport',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectDetails',
              isRead: 'true',
              interval: '625',
              texttableentry: 'ObjectDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_VentilationMatrix',
              isRead: 'true',
              interval: '626',
              texttableentry: 'VentilationMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingOneCircuitName',
              isRead: 'true',
              interval: '627',
              texttableentry: 'CentralHeatingOneCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTwoCircuitName',
              isRead: 'true',
              interval: '628',
              texttableentry: 'CentralHeatingTwoCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingThreeCircuitName',
              isRead: 'true',
              interval: '629',
              texttableentry: 'CentralHeatingThreeCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFourCircuitName',
              isRead: 'true',
              interval: '630',
              texttableentry: 'CentralHeatingFourCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '645',
              texttableentry: 'GenericAnalogDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '646',
              texttableentry: 'GenericAnalogDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '647',
              texttableentry: 'GenericAnalogDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFourModulFunction',
              isRead: 'true',
              interval: '648',
              texttableentry: 'GenericAnalogDigitalAccessoryFourModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFiveModulFunction',
              isRead: 'true',
              interval: '649',
              texttableentry: 'GenericAnalogDigitalAccessoryFiveModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '650',
              texttableentry: 'GenericDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '651',
              texttableentry: 'GenericDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '652',
              texttableentry: 'GenericDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMTwoIoAccessoryOneModuleFunction',
              isRead: 'true',
              interval: '676',
              texttableentry: 'GenericMTwoIoAccessoryOneModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyMeter',
              isRead: 'true',
              interval: '680',
              texttableentry: 'EnergyMeter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleMonday',
              isRead: 'true',
              interval: '691',
              texttableentry: 'DomesticHotWaterTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleTuesday',
              isRead: 'true',
              interval: '692',
              texttableentry: 'DomesticHotWaterTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleWednesday',
              isRead: 'true',
              interval: '693',
              texttableentry: 'DomesticHotWaterTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleThursday',
              isRead: 'true',
              interval: '694',
              texttableentry: 'DomesticHotWaterTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleFriday',
              isRead: 'true',
              interval: '695',
              texttableentry: 'DomesticHotWaterTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSaturday',
              isRead: 'true',
              interval: '696',
              texttableentry: 'DomesticHotWaterTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSunday',
              isRead: 'true',
              interval: '697',
              texttableentry: 'DomesticHotWaterTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleMonday',
              isRead: 'true',
              interval: '726',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleTuesday',
              isRead: 'true',
              interval: '727',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleWednesday',
              isRead: 'true',
              interval: '728',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleThursday',
              isRead: 'true',
              interval: '729',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleFriday',
              isRead: 'true',
              interval: '730',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSaturday',
              isRead: 'true',
              interval: '731',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSunday',
              isRead: 'true',
              interval: '732',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '761',
              texttableentry: 'MixerOneCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '762',
              texttableentry: 'MixerOneCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '763',
              texttableentry: 'MixerOneCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '764',
              texttableentry: 'MixerOneCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '765',
              texttableentry: 'MixerOneCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '766',
              texttableentry: 'MixerOneCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '767',
              texttableentry: 'MixerOneCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '768',
              texttableentry: 'MixerTwoCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '769',
              texttableentry: 'MixerTwoCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '770',
              texttableentry: 'MixerTwoCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '771',
              texttableentry: 'MixerTwoCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '772',
              texttableentry: 'MixerTwoCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '773',
              texttableentry: 'MixerTwoCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '774',
              texttableentry: 'MixerTwoCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '775',
              texttableentry: 'MixerThreeCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '776',
              texttableentry: 'MixerThreeCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '777',
              texttableentry: 'MixerThreeCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '778',
              texttableentry: 'MixerThreeCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '779',
              texttableentry: 'MixerThreeCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '780',
              texttableentry: 'MixerThreeCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '781',
              texttableentry: 'MixerThreeCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '782',
              texttableentry: 'MixerFourCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '783',
              texttableentry: 'MixerFourCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '784',
              texttableentry: 'MixerFourCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '785',
              texttableentry: 'MixerFourCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '786',
              texttableentry: 'MixerFourCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '787',
              texttableentry: 'MixerFourCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '788',
              texttableentry: 'MixerFourCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionActivation',
              isRead: 'true',
              interval: '873',
              texttableentry: 'LegionellaProtectionActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '874',
              texttableentry: 'LegionellaProtectionTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionStartTime',
              isRead: 'true',
              interval: '875',
              texttableentry: 'LegionellaProtectionStartTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionWeekday',
              isRead: 'true',
              interval: '876',
              texttableentry: 'LegionellaProtectionWeekday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulStartTime',
              isRead: 'true',
              interval: '877',
              texttableentry: 'LegionellaProtectionLastSuccessfulStartTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulWeekday',
              isRead: 'true',
              interval: '878',
              texttableentry: 'LegionellaProtectionLastSuccessfulWeekday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '880',
              texttableentry: 'MixerOneCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '881',
              texttableentry: 'MixerTwoCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '882',
              texttableentry: 'MixerThreeCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '883',
              texttableentry: 'MixerFourCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureOffset',
              isRead: 'true',
              interval: '896',
              texttableentry: 'OutsideTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingProfileActivation',
              isRead: 'true',
              interval: '897',
              texttableentry: 'ScreedDryingProfileActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemainingFloorDryingDays',
              isRead: 'true',
              interval: '898',
              texttableentry: 'RemainingFloorDryingDays',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMenuPassword',
              isRead: 'true',
              interval: '899',
              texttableentry: 'DiagnosticMenuPassword',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceManagerIsRequired',
              isRead: 'true',
              interval: '901',
              texttableentry: 'ServiceManagerIsRequired',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdenification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyType',
              isRead: 'true',
              interval: '904',
              texttableentry: 'EnergyType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UserInterfaceDefaultHomeScreen',
              isRead: 'true',
              interval: '907',
              texttableentry: 'UserInterfaceDefaultHomeScreen',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignal',
              isRead: 'true',
              interval: '908',
              texttableentry: 'ExternalFaultSignal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignalInput',
              isRead: 'true',
              interval: '909',
              texttableentry: 'ExternalFaultSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherService',
              isRead: 'true',
              interval: '917',
              texttableentry: 'RemoteWeatherService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureDampingFactor',
              isRead: 'true',
              interval: '919',
              texttableentry: 'OutsideTemperatureDampingFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreeAxisAccelerationSensor',
              isRead: 'true',
              interval: '920',
              texttableentry: 'ThreeAxisAccelerationSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAccessInProgress',
              isRead: 'true',
              interval: '921',
              texttableentry: 'ExternalAccessInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RealTimeClockStatus',
              isRead: 'true',
              interval: '923',
              texttableentry: 'RealTimeClockStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FillingVenting',
              isRead: 'true',
              interval: '925',
              texttableentry: 'FillingVenting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyCockpitVisible',
              isRead: 'true',
              interval: '926',
              texttableentry: 'EnergyCockpitVisible',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BuildingType',
              isRead: 'true',
              interval: '927',
              texttableentry: 'BuildingType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalTargetCentralHeatingFlowSetpointMetaData',
              isRead: 'true',
              interval: '930',
              texttableentry: 'ExternalTargetCentralHeatingFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSetpointMetaData',
              isRead: 'true',
              interval: '931',
              texttableentry: 'DomesticHotWaterFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitProperty',
              isRead: 'true',
              interval: '933',
              texttableentry: 'MixerOneCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitProperty',
              isRead: 'true',
              interval: '934',
              texttableentry: 'MixerTwoCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitProperty',
              isRead: 'true',
              interval: '935',
              texttableentry: 'MixerThreeCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitProperty',
              isRead: 'true',
              interval: '936',
              texttableentry: 'MixerFourCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingDocumentation',
              isRead: 'true',
              interval: '949',
              texttableentry: 'ScreedDryingDocumentation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrix',
              isRead: 'true',
              interval: '952',
              texttableentry: 'HydraulicMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYield',
              isRead: 'true',
              interval: '953',
              texttableentry: 'SolarEnergyYield',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BackLightRemainingTime',
              isRead: 'true',
              interval: '956',
              texttableentry: 'BackLightRemainingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SparePartNumber',
              isRead: 'true',
              interval: '963',
              texttableentry: 'SparePartNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '987',
              texttableentry: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '988',
              texttableentry: 'MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '989',
              texttableentry: 'MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '990',
              texttableentry: 'MixerFourCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TestOperationMode',
              isRead: 'true',
              interval: '1003',
              texttableentry: 'TestOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingRegulationMode',
              isRead: 'true',
              interval: '1004',
              texttableentry: 'CentralHeatingRegulationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetQuickMode',
              isRead: 'true',
              interval: '1006',
              texttableentry: 'TargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentQuickMode',
              isRead: 'true',
              interval: '1007',
              texttableentry: 'CurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1008',
              texttableentry: 'MixerOneCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1009',
              texttableentry: 'MixerTwoCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1010',
              texttableentry: 'MixerThreeCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1011',
              texttableentry: 'MixerFourCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1024',
              texttableentry: 'MixerOneCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1025',
              texttableentry: 'MixerTwoCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1026',
              texttableentry: 'MixerThreeCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1027',
              texttableentry: 'MixerFourCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AllengraSensor',
              isRead: 'true',
              interval: '1043',
              texttableentry: 'AllengraSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceIndividualisationPartOne',
              isRead: 'true',
              interval: '1045',
              texttableentry: 'DeviceIndividualisationPartOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpPostRuntime',
              isRead: 'true',
              interval: '1083',
              texttableentry: 'CentralHeatingPumpPostRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterHysteresis',
              isRead: 'true',
              interval: '1085',
              texttableentry: 'DomesticHotWaterHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaximumDomesticHotWaterLoadingTime',
              isRead: 'true',
              interval: '1087',
              texttableentry: 'MaximumDomesticHotWaterLoadingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetEnergyManagerDataCollector',
              isRead: 'true',
              interval: '1096',
              texttableentry: 'ResetEnergyManagerDataCollector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPrice',
              isRead: 'true',
              interval: '1097',
              texttableentry: 'ElectricityPrice',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasProperties',
              isRead: 'true',
              interval: '1098',
              texttableentry: 'GasProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1100',
              texttableentry: 'CentralHeatingPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1101',
              texttableentry: 'DomesticHotWaterPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1102',
              texttableentry: 'MixerOneCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1103',
              texttableentry: 'MixerTwoCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1104',
              texttableentry: 'MixerThreeCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1105',
              texttableentry: 'MixerFourCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1119',
              texttableentry: 'DomesticHotWaterCirculationPumpMinimumMaximumLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarAlternatelyChargeMaximumLoadingTime',
              isRead: 'true',
              interval: '1130',
              texttableentry: 'SolarAlternatelyChargeMaximumLoadingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccentLedBar',
              isRead: 'true',
              interval: '1138',
              texttableentry: 'AccentLedBar',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingCurveAdaptionParameter',
              isRead: 'true',
              interval: '1139',
              texttableentry: 'CentralHeatingCurveAdaptionParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1167',
              texttableentry: 'ExternalDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpStatistical',
              isRead: 'true',
              interval: '1172',
              texttableentry: 'SolarCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayPowerSavingMode',
              isRead: 'true',
              interval: '1180',
              texttableentry: 'DisplayPowerSavingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermalPower',
              isRead: 'true',
              interval: '1190',
              texttableentry: 'ThermalPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1192',
              texttableentry: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1193',
              texttableentry: 'MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1194',
              texttableentry: 'MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1195',
              texttableentry: 'MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutput',
              isRead: 'true',
              interval: '1211',
              texttableentry: 'GeneratedCentralHeatingOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationNumber',
              isRead: 'true',
              interval: '1213',
              texttableentry: 'ParameterIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardOne',
              isRead: 'true',
              interval: '1232',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AvailableActorSensorComponents',
              isRead: 'true',
              interval: '1238',
              texttableentry: 'AvailableActorSensorComponents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMode',
              isRead: 'true',
              interval: '1240',
              texttableentry: 'CentralHeatingPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpMode',
              isRead: 'true',
              interval: '1241',
              texttableentry: 'MixerOneCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpMode',
              isRead: 'true',
              interval: '1242',
              texttableentry: 'MixerTwoCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpMode',
              isRead: 'true',
              interval: '1243',
              texttableentry: 'MixerThreeCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpMode',
              isRead: 'true',
              interval: '1244',
              texttableentry: 'MixerFourCircuitPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveStatistical',
              isRead: 'true',
              interval: '1266',
              texttableentry: 'DiverterValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceParameter',
              isRead: 'true',
              interval: '1283',
              texttableentry: 'HeatEnginePerformanceParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPump',
              isRead: 'true',
              interval: '1290',
              texttableentry: 'DomesticHotWaterShiftLoadPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpStatistical',
              isRead: 'true',
              interval: '1291',
              texttableentry: 'DomesticHotWaterShiftLoadPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1294',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1311',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingMonthMatrix',
              isRead: 'true',
              interval: '1312',
              texttableentry: 'EnergyConsumptionCoolingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldMonthMatrix',
              isRead: 'true',
              interval: '1314',
              texttableentry: 'SolarEnergyYieldMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputMonthMatrix',
              isRead: 'true',
              interval: '1315',
              texttableentry: 'GeneratedCentralHeatingOutputMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1316',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1333',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCoolingYearMatrix',
              isRead: 'true',
              interval: '1334',
              texttableentry: 'EnergyConsumptionCoolingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldYearMatrix',
              isRead: 'true',
              interval: '1336',
              texttableentry: 'SolarEnergyYieldYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputYearMatrix',
              isRead: 'true',
              interval: '1337',
              texttableentry: 'GeneratedCentralHeatingOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FloorDryingProfileDefinition',
              isRead: 'true',
              interval: '1338',
              texttableentry: 'ScreedDryingProfileDefinition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionHeatingUnitBlocked',
              isRead: 'true',
              interval: '1339',
              texttableentry: 'MalfunctionHeatingUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatistical',
              isRead: 'true',
              interval: '1346',
              texttableentry: 'HeatEngineStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericSdioAccessoryOneModulFunction',
              isRead: 'true',
              interval: '1364',
              texttableentry: 'GenericSdioAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutput',
              isRead: 'true',
              interval: '1391',
              texttableentry: 'GeneratedDomesticHotWaterOutput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputMonthMatrix',
              isRead: 'true',
              interval: '1392',
              texttableentry: 'GeneratedDomesticHotWaterOutputMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputYearMatrix',
              isRead: 'true',
              interval: '1393',
              texttableentry: 'GeneratedDomesticHotWaterOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarChargingDomesticHotWaterSetpoint',
              isRead: 'true',
              interval: '1394',
              texttableentry: 'SolarChargingDomesticHotWaterSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1395',
              texttableentry: 'MixerOneCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1396',
              texttableentry: 'MixerTwoCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1397',
              texttableentry: 'MixerThreeCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1398',
              texttableentry: 'MixerFourCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitOperationState',
              isRead: 'true',
              interval: '1415',
              texttableentry: 'MixerOneCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitOperationState',
              isRead: 'true',
              interval: '1416',
              texttableentry: 'MixerTwoCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitOperationState',
              isRead: 'true',
              interval: '1417',
              texttableentry: 'MixerThreeCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitOperationState',
              isRead: 'true',
              interval: '1418',
              texttableentry: 'MixerFourCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleMonday',
              isRead: 'true',
              interval: '1439',
              texttableentry: 'NoiseReductionTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleTuesday',
              isRead: 'true',
              interval: '1440',
              texttableentry: 'NoiseReductionTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleWednesday',
              isRead: 'true',
              interval: '1441',
              texttableentry: 'NoiseReductionTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleThursday',
              isRead: 'true',
              interval: '1442',
              texttableentry: 'NoiseReductionTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleFriday',
              isRead: 'true',
              interval: '1443',
              texttableentry: 'NoiseReductionTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleSaturday',
              isRead: 'true',
              interval: '1444',
              texttableentry: 'NoiseReductionTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionTimeScheduleSunday',
              isRead: 'true',
              interval: '1445',
              texttableentry: 'NoiseReductionTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatEngine',
              isRead: 'true',
              interval: '1469',
              texttableentry: 'SensorActuatorTestGroupHeatEngine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupDomesticHotWater',
              isRead: 'true',
              interval: '1470',
              texttableentry: 'SensorActuatorTestGroupDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatingCircuit',
              isRead: 'true',
              interval: '1472',
              texttableentry: 'SensorActuatorTestGroupHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupSolar',
              isRead: 'true',
              interval: '1473',
              texttableentry: 'SensorActuatorTestGroupSolar',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceStatistics',
              isRead: 'true',
              interval: '1493',
              texttableentry: 'HeatEnginePerformanceStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarRechargeSuppressionImpact',
              isRead: 'true',
              interval: '1529',
              texttableentry: 'SolarRechargeSuppressionImpact',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoSelector',
              isRead: 'true',
              interval: '1534',
              texttableentry: 'DeviceAnalogInputTwoFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitWaterFlowTestMode',
              isRead: 'true',
              interval: '1536',
              texttableentry: 'PrimaryCircuitWaterFlowTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ChimneySweeperTestMode',
              isRead: 'true',
              interval: '1537',
              texttableentry: 'ChimneySweeperTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionPump',
              isRead: 'true',
              interval: '1541',
              texttableentry: 'LegionellaProtectionPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrixConfiguration',
              isRead: 'true',
              interval: '1549',
              texttableentry: 'HydraulicMatrixConfiguration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupport',
              isRead: 'true',
              interval: '1554',
              texttableentry: 'HeatingSupport',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1555',
              texttableentry: 'MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1556',
              texttableentry: 'MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1557',
              texttableentry: 'MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1558',
              texttableentry: 'MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpTargetSpeedSetpoint',
              isRead: 'true',
              interval: '1583',
              texttableentry: 'CentralHeatingPumpTargetSpeedSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastApplicationUpdate',
              isRead: 'true',
              interval: '1594',
              texttableentry: 'LastApplicationUpdate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalTargetFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1604',
              texttableentry: 'GatewayExternalTargetFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalHeatEngineTargetOperationMode',
              isRead: 'true',
              interval: '1605',
              texttableentry: 'GatewayExternalHeatEngineTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionUnitBlocked',
              isRead: 'true',
              interval: '1607',
              texttableentry: 'MalfunctionUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isRead: 'true',
              interval: '1608',
              texttableentry: 'DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '1609',
              texttableentry: 'DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferTemperatureSensor',
              isRead: 'true',
              interval: '1610',
              texttableentry: 'HeatingSupportBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1612',
              texttableentry: 'ExternalMixerTwoCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1613',
              texttableentry: 'ExternalMixerThreeCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1614',
              texttableentry: 'ExternalMixerFourCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1627',
              texttableentry: 'ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1628',
              texttableentry: 'ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1629',
              texttableentry: 'ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1630',
              texttableentry: 'ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1643',
              texttableentry: 'MixerOneCircuitCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1644',
              texttableentry: 'MixerTwoCircuitCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1645',
              texttableentry: 'MixerThreeCircuitCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1646',
              texttableentry: 'MixerFourCircuitCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EndResultDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1659',
              texttableentry: 'EndResultDomesticHotWaterTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryTransferPump',
              isRead: 'true',
              interval: '1661',
              texttableentry: 'SolarSecondaryTransferPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '1662',
              texttableentry: 'HeatingSupportBufferThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1667',
              texttableentry: 'MixerOneCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1668',
              texttableentry: 'MixerTwoCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1669',
              texttableentry: 'MixerThreeCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1670',
              texttableentry: 'MixerFourCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyScanStatus',
              isRead: 'true',
              interval: '1691',
              texttableentry: 'BusTopologyScanStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FunctionalSoftwareVersion',
              isRead: 'true',
              interval: '1710',
              texttableentry: 'FunctionalSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureConfiguration',
              isRead: 'true',
              interval: '1721',
              texttableentry: 'WaterPressureConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalLockActive',
              isRead: 'true',
              interval: '1731',
              texttableentry: 'ExternalLockActive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReceiverTemperatureSensor',
              isRead: 'true',
              interval: '1768',
              texttableentry: 'ReceiverTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryInletTemperatureSensor',
              isRead: 'true',
              interval: '1769',
              texttableentry: 'PrimaryInletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryOutletTemperatureSensor',
              isRead: 'true',
              interval: '1770',
              texttableentry: 'SecondaryOutletTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EngineRoomTemperatureSensor',
              isRead: 'true',
              interval: '1771',
              texttableentry: 'EngineRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOilTemperatureSensor',
              isRead: 'true',
              interval: '1772',
              texttableentry: 'CompressorOilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCircuitFourWayValve',
              isRead: 'true',
              interval: '1773',
              texttableentry: 'RefrigerantCircuitFourWayValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorCrankCaseHeater',
              isRead: 'true',
              interval: '1774',
              texttableentry: 'CompressorCrankCaseHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanOne',
              isRead: 'true',
              interval: '1775',
              texttableentry: 'PrimaryCircuitFanOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitFanTwo',
              isRead: 'true',
              interval: '1776',
              texttableentry: 'PrimaryCircuitFanTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressureStagnation',
              isRead: 'true',
              interval: '1786',
              texttableentry: 'TimeSeriesRecordedWaterPressureStagnation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressurePeaks',
              isRead: 'true',
              interval: '1787',
              texttableentry: 'TimeSeriesRecordedWaterPressurePeaks',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CanInterfaceVersion',
              isRead: 'true',
              interval: '1788',
              texttableentry: 'CanInterfaceVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiverterValveDefaultPositionConfiguration',
              isRead: 'true',
              interval: '1791',
              texttableentry: 'DiverterValveDefaultPositionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1799',
              texttableentry: 'PrimaryCircuitCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionValve',
              isRead: 'true',
              interval: '1813',
              texttableentry: 'EnhancedVapourInjectionValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ReceiverLiquidLevelSensor',
              isRead: 'true',
              interval: '1814',
              texttableentry: 'ReceiverLiquidLevelSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseOne',
              isRead: 'true',
              interval: '1815',
              texttableentry: 'ElectricalHeaterPhaseOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseTwo',
              isRead: 'true',
              interval: '1816',
              texttableentry: 'ElectricalHeaterPhaseTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseThree',
              isRead: 'true',
              interval: '1817',
              texttableentry: 'ElectricalHeaterPhaseThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarPumpConfigurationSelection',
              isRead: 'true',
              interval: '1819',
              texttableentry: 'SolarPumpConfigurationSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpCharacteristics',
              isRead: 'true',
              interval: '1820',
              texttableentry: 'SolarPumpCharacteristics',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrentPower',
              isRead: 'true',
              interval: '1824',
              texttableentry: 'ThreePhaseInverterCurrentPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryCircuitFourThreeWayValve',
              isRead: 'true',
              interval: '1842',
              texttableentry: 'SecondaryCircuitFourThreeWayValve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitHumidityProtection',
              isRead: 'true',
              interval: '1843',
              texttableentry: 'MixerOneCircuitHumidityProtection',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitHumidityProtection',
              isRead: 'true',
              interval: '1844',
              texttableentry: 'MixerTwoCircuitHumidityProtection',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorCurrentOperatingPoint',
              isRead: 'true',
              interval: '1846',
              texttableentry: 'HeatPumpCompressorCurrentOperatingPoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2166',
              texttableentry: 'MixerOneCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2167',
              texttableentry: 'MixerTwoCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2168',
              texttableentry: 'MixerThreeCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2169',
              texttableentry: 'MixerFourCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2170',
              texttableentry: 'MixerFiveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2171',
              texttableentry: 'MixerSixCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2172',
              texttableentry: 'MixerSevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2173',
              texttableentry: 'MixerEightCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2174',
              texttableentry: 'MixerNineCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2175',
              texttableentry: 'MixerTenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2176',
              texttableentry: 'MixerElevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2177',
              texttableentry: 'MixerTwelveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2178',
              texttableentry: 'MixerThirteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2179',
              texttableentry: 'MixerFourteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2180',
              texttableentry: 'MixerFifteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2181',
              texttableentry: 'MixerSixteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterActivationControl',
              isRead: 'true',
              interval: '2215',
              texttableentry: 'DomesticHotWaterActivationControl',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterComfortModeActivation',
              isRead: 'true',
              interval: '2216',
              texttableentry: 'DomesticHotWaterComfortModeActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StartUpdatePersistentStorage',
              isRead: 'true',
              interval: '2232',
              texttableentry: 'StartUpdatePersistentStorage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentStorageStatus',
              isRead: 'true',
              interval: '2233',
              texttableentry: 'PersistentStorageStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfiguration',
              isRead: 'true',
              interval: '2235',
              texttableentry: 'CascadeSystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumSecondaryReturnTemperatureRefrigerantCircui',
              isRead: 'true',
              interval: '2255',
              texttableentry: 'MinimumSecondaryReturnTemperatureRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalEnergyDefrost',
              isRead: 'true',
              interval: '2256',
              texttableentry: 'DesiredThermalEnergyDefrost',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointOffset',
              isRead: 'true',
              interval: '2257',
              texttableentry: 'DomesticHotWaterTemperatureSetpointOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitStatus',
              isRead: 'true',
              interval: '2259',
              texttableentry: 'RefrigerationCircuitStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterStatus',
              isRead: 'true',
              interval: '2320',
              texttableentry: 'DomesticHotWaterStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardTwo',
              isRead: 'true',
              interval: '2330',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardThree',
              isRead: 'true',
              interval: '2331',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardFour',
              isRead: 'true',
              interval: '2332',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EconomizerLiquidTemperatureSensor',
              isRead: 'true',
              interval: '2333',
              texttableentry: 'EconomizerLiquidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EvaporatorVaporTemperatureSensor',
              isRead: 'true',
              interval: '2334',
              texttableentry: 'EvaporatorVaporTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterConfiguration',
              isRead: 'true',
              interval: '2340',
              texttableentry: 'ElectricalHeaterConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoefficientOfPerformanceConfiguration',
              isRead: 'true',
              interval: '2341',
              texttableentry: 'CoefficientOfPerformanceConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityHeating',
              isRead: 'true',
              interval: '2342',
              texttableentry: 'NominalThermalCapacityHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityCooling',
              isRead: 'true',
              interval: '2343',
              texttableentry: 'NominalThermalCapacityCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorSetpointPercent',
              isRead: 'true',
              interval: '2345',
              texttableentry: 'CompressorSetpointPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedPercent',
              isRead: 'true',
              interval: '2346',
              texttableentry: 'CompressorSpeedPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyManagmentSystemResultingControlState',
              isRead: 'true',
              interval: '2350',
              texttableentry: 'EnergyManagmentSystemResultingControlState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressor',
              isRead: 'true',
              interval: '2351',
              texttableentry: 'HeatPumpCompressor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AdditionalElectricHeater',
              isRead: 'true',
              interval: '2352',
              texttableentry: 'AdditionalElectricHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OpenSourceLicenses',
              isRead: 'true',
              interval: '2357',
              texttableentry: 'OpenSourceLicenses',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortReducedPropertiesSettings',
              isRead: 'true',
              interval: '2361',
              texttableentry: 'ClimateComfortReducedPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortNormalPropertiesSettings',
              isRead: 'true',
              interval: '2362',
              texttableentry: 'ClimateComfortNormalPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortComfortPropertiesSettings',
              isRead: 'true',
              interval: '2363',
              texttableentry: 'ClimateComfortComfortPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortIntensivePropertiesSettings',
              isRead: 'true',
              interval: '2364',
              texttableentry: 'ClimateComfortIntensivePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortHolidayAtHomePropertiesSettings',
              isRead: 'true',
              interval: '2365',
              texttableentry: 'ClimateComfortHolidayAtHomePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortHolidayAwayPropertiesSettings',
              isRead: 'true',
              interval: '2366',
              texttableentry: 'ClimateComfortHolidayAwayPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortPartyPropertiesSettings',
              isRead: 'true',
              interval: '2367',
              texttableentry: 'ClimateComfortPartyPropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ClimateComfortOneTimePropertiesSettings',
              isRead: 'true',
              interval: '2368',
              texttableentry: 'ClimateComfortOneTimePropertiesSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpCompressorStatistical',
              isRead: 'true',
              interval: '2369',
              texttableentry: 'HeatPumpCompressorStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AdditionalElectricHeaterStatistical',
              isRead: 'true',
              interval: '2370',
              texttableentry: 'AdditionalElectricHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutdoorUnitDefrostingFunction',
              isRead: 'true',
              interval: '2381',
              texttableentry: 'OutdoorUnitDefrostingFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BivalenceControlMode',
              isRead: 'true',
              interval: '2404',
              texttableentry: 'BivalenceControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2405',
              texttableentry: 'MixerOneCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2406',
              texttableentry: 'MixerTwoCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2407',
              texttableentry: 'MixerThreeCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitConstantFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2408',
              texttableentry: 'MixerFourCircuitConstantFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2409',
              texttableentry: 'MixerOneCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2410',
              texttableentry: 'MixerTwoCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2411',
              texttableentry: 'MixerThreeCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitMinimumMaximumFlowSetTemperatureCooling',
              isRead: 'true',
              interval: '2412',
              texttableentry: 'MixerFourCircuitMinimumMaximumFlowSetTemperatureCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThresholdCooling',
              isRead: 'true',
              interval: '2413',
              texttableentry: 'MixerOneCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThresholdCooling',
              isRead: 'true',
              interval: '2414',
              texttableentry: 'MixerTwoCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThresholdCooling',
              isRead: 'true',
              interval: '2415',
              texttableentry: 'MixerThreeCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThresholdCooling',
              isRead: 'true',
              interval: '2416',
              texttableentry: 'MixerFourCircuitThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2417',
              texttableentry: 'MixerOneCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2418',
              texttableentry: 'MixerTwoCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2419',
              texttableentry: 'MixerThreeCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTargetValueRelativeHumidityCooling',
              isRead: 'true',
              interval: '2420',
              texttableentry: 'MixerFourCircuitTargetValueRelativeHumidityCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2421',
              texttableentry: 'MixerOneCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2422',
              texttableentry: 'MixerTwoCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2423',
              texttableentry: 'MixerThreeCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTemperatureOffsetCooling',
              isRead: 'true',
              interval: '2424',
              texttableentry: 'MixerFourCircuitTemperatureOffsetCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2426',
              texttableentry: 'MixerOneCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2427',
              texttableentry: 'MixerTwoCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2428',
              texttableentry: 'MixerThreeCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2429',
              texttableentry: 'MixerFourCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2452',
              texttableentry: 'MixerOneCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2453',
              texttableentry: 'MixerTwoCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2454',
              texttableentry: 'MixerThreeCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureThresholdCooling',
              isRead: 'true',
              interval: '2455',
              texttableentry: 'MixerFourCircuitRoomTemperatureThresholdCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CalculatedOutsideTemperature',
              isRead: 'true',
              interval: '2457',
              texttableentry: 'CalculatedOutsideTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RoomAirHumiditySensor',
              isRead: 'true',
              interval: '2478',
              texttableentry: 'RoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2479',
              texttableentry: 'MixerOneCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2480',
              texttableentry: 'MixerTwoCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2481',
              texttableentry: 'MixerThreeCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomAirHumiditySensor',
              isRead: 'true',
              interval: '2482',
              texttableentry: 'MixerFourCircuitRoomAirHumiditySensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OpenThermConfiguration',
              isRead: 'true',
              interval: '2483',
              texttableentry: 'OpenThermConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerRangeMetaData',
              isRead: 'true',
              interval: '2484',
              texttableentry: 'ElectricalPowerRangeMetaData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyTotalConsumption',
              isRead: 'true',
              interval: '2485',
              texttableentry: 'ElectricalEnergyTotalConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isRead: 'true',
              interval: '2486',
              texttableentry: 'CurrentElectricalPowerConsumptionRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionElectricHeater',
              isRead: 'true',
              interval: '2487',
              texttableentry: 'CurrentElectricalPowerConsumptionElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalPowerConsumptionSystem',
              isRead: 'true',
              interval: '2488',
              texttableentry: 'CurrentElectricalPowerConsumptionSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterDemandInput',
              isRead: 'true',
              interval: '2491',
              texttableentry: 'DomesticHotWaterDemandInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacityRefrigerantCircuit',
              isRead: 'true',
              interval: '2494',
              texttableentry: 'CurrentThermalCapacityRefrigerantCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacityElectricHeater',
              isRead: 'true',
              interval: '2495',
              texttableentry: 'CurrentThermalCapacityElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentThermalCapacitySystem',
              isRead: 'true',
              interval: '2496',
              texttableentry: 'CurrentThermalCapacitySystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpType',
              isRead: 'true',
              interval: '2498',
              texttableentry: 'CentralHeatingPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpType',
              isRead: 'true',
              interval: '2499',
              texttableentry: 'MixerOneCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpType',
              isRead: 'true',
              interval: '2500',
              texttableentry: 'MixerTwoCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpType',
              isRead: 'true',
              interval: '2501',
              texttableentry: 'MixerThreeCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpType',
              isRead: 'true',
              interval: '2502',
              texttableentry: 'MixerFourCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPumpType',
              isRead: 'true',
              interval: '2503',
              texttableentry: 'MixerFiveCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPumpType',
              isRead: 'true',
              interval: '2504',
              texttableentry: 'MixerSixCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPumpType',
              isRead: 'true',
              interval: '2505',
              texttableentry: 'MixerSevenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPumpType',
              isRead: 'true',
              interval: '2506',
              texttableentry: 'MixerEightCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitPumpType',
              isRead: 'true',
              interval: '2507',
              texttableentry: 'MixerNineCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitPumpType',
              isRead: 'true',
              interval: '2508',
              texttableentry: 'MixerTenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitPumpType',
              isRead: 'true',
              interval: '2509',
              texttableentry: 'MixerElevenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitPumpType',
              isRead: 'true',
              interval: '2510',
              texttableentry: 'MixerTwelveCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitPumpType',
              isRead: 'true',
              interval: '2511',
              texttableentry: 'MixerThirteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitPumpType',
              isRead: 'true',
              interval: '2512',
              texttableentry: 'MixerFourteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitPumpType',
              isRead: 'true',
              interval: '2513',
              texttableentry: 'MixerFifteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitPumpType',
              isRead: 'true',
              interval: '2514',
              texttableentry: 'MixerSixteenCircuitPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrixElectricHeater',
              isRead: 'true',
              interval: '2515',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrixElectricHeater',
              isRead: 'true',
              interval: '2516',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterElectricHeater',
              isRead: 'true',
              interval: '2517',
              texttableentry: 'EnergyConsumptionDomesticHotWaterElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrixElectricHeater',
              isRead: 'true',
              interval: '2524',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrixElectricHeater',
              isRead: 'true',
              interval: '2525',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrixElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingElectricHeater',
              isRead: 'true',
              interval: '2526',
              texttableentry: 'EnergyConsumptionCentralHeatingElectricHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutputMonthMatrix',
              isRead: 'true',
              interval: '2527',
              texttableentry: 'GeneratedCoolingOutputMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutputYearMatrix',
              isRead: 'true',
              interval: '2528',
              texttableentry: 'GeneratedCoolingOutputYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedCoolingOutput',
              isRead: 'true',
              interval: '2529',
              texttableentry: 'GeneratedCoolingOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionSettings',
              isRead: 'true',
              interval: '2540',
              texttableentry: 'NoiseReductionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SmartGridTemperatureOffsets',
              isRead: 'true',
              interval: '2543',
              texttableentry: 'SmartGridTemperatureOffsets',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridLock',
              isRead: 'true',
              interval: '2544',
              texttableentry: 'EnableElectricalHeaterSmartGridLock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridIncreaseMaxDemand',
              isRead: 'true',
              interval: '2545',
              texttableentry: 'EnableElectricalHeaterSmartGridIncreaseMaxDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2546',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2547',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2548',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSetpointCooling',
              isRead: 'true',
              interval: '2549',
              texttableentry: 'MixerFourCircuitRoomTemperatureSetpointCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerSetPoint',
              isRead: 'true',
              interval: '2555',
              texttableentry: 'ElectricalPowerSetPoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyRemainingCapacity',
              isRead: 'true',
              interval: '2556',
              texttableentry: 'ElectricalEnergyRemainingCapacity',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatPumpState',
              isRead: 'true',
              interval: '2557',
              texttableentry: 'HeatPumpState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatPumpSupportedStates',
              isRead: 'true',
              interval: '2558',
              texttableentry: 'HeatPumpSupportedStates',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SmartGridFeatureSelection',
              isRead: 'true',
              interval: '2560',
              texttableentry: 'SmartGridFeatureSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentCoefficientOfPerformance',
              isRead: 'true',
              interval: '2561',
              texttableentry: 'CurrentCoefficientOfPerformance',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorSpeedRps',
              isRead: 'true',
              interval: '2569',
              texttableentry: 'CompressorSpeedRps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOnTimer',
              isRead: 'true',
              interval: '2573',
              texttableentry: 'CompressorOnTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NominalPowerElectricalHeater',
              isRead: 'true',
              interval: '2574',
              texttableentry: 'NominalPowerElectricalHeater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCycleApplicationState',
              isRead: 'true',
              interval: '2575',
              texttableentry: 'RefrigerationCycleApplicationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorOffTimer',
              isRead: 'true',
              interval: '2582',
              texttableentry: 'CompressorOffTimer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalOutputCooling',
              isRead: 'true',
              interval: '2586',
              texttableentry: 'DigitalOutputCooling',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrix',
              isRead: 'true',
              interval: '2593',
              texttableentry: 'ProductMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaicMonthMatrix',
              isRead: 'true',
              interval: '2596',
              texttableentry: 'EnergyProductionPhotovoltaicMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaicYearMatrix',
              isRead: 'true',
              interval: '2597',
              texttableentry: 'EnergyProductionPhotovoltaicYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NominalThermalCapacityIndoorUnit',
              isRead: 'true',
              interval: '2611',
              texttableentry: 'NominalThermalCapacityIndoorUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceHeating',
              isRead: 'true',
              interval: '2622',
              texttableentry: 'SeasonalCoefficientOfPerformaceHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalEnergyEfficiencyRatioCooling',
              isRead: 'true',
              interval: '2623',
              texttableentry: 'SeasonalEnergyEfficiencyRatioCooling',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceDomesticHotWater',
              isRead: 'true',
              interval: '2624',
              texttableentry: 'SeasonalCoefficientOfPerformaceDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SeasonalCoefficientOfPerformaceHeatingAndDomesticHotWater',
              isRead: 'true',
              interval: '2625',
              texttableentry: 'SeasonalCoefficientOfPerformaceHeatingAndDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MaximumPowerElectricalHeater',
              isRead: 'true',
              interval: '2626',
              texttableentry: 'MaximumPowerElectricalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingActivation',
              isRead: 'true',
              interval: '2628',
              texttableentry: 'ScreedDryingActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DesiredThermalCapacity',
              isRead: 'true',
              interval: '2629',
              texttableentry: 'DesiredThermalCapacity',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NoiseReductionMode',
              isRead: 'true',
              interval: '2634',
              texttableentry: 'NoiseReductionMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OverTheAirUpdateStatus',
              isRead: 'true',
              interval: '2644',
              texttableentry: 'OverTheAirUpdateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationConfirmation',
              isRead: 'true',
              interval: '2733',
              texttableentry: 'InstallationConfirmation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FourThreeWayValveValveCurrentPosition',
              isRead: 'true',
              interval: '2735',
              texttableentry: 'FourThreeWayValveValveCurrentPosition',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuringMode',
              isRead: 'true',
              interval: '2741',
              texttableentry: 'ComfortEnsuringMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterInterval',
              isRead: 'true',
              interval: '2742',
              texttableentry: 'DiagnosticHydraulicFilterInterval',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticElectricalHeaterSafetyTemperatureLimiter',
              isRead: 'true',
              interval: '2743',
              texttableentry: 'DiagnosticElectricalHeaterSafetyTemperatureLimiter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticSecondaryFourThreeWayValve',
              isRead: 'true',
              interval: '2744',
              texttableentry: 'DiagnosticSecondaryFourThreeWayValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterContamination',
              isRead: 'true',
              interval: '2745',
              texttableentry: 'DiagnosticHydraulicFilterContamination',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicSafetyValve',
              isRead: 'true',
              interval: '2746',
              texttableentry: 'DiagnosticHydraulicSafetyValve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicTemperatureSensors',
              isRead: 'true',
              interval: '2750',
              texttableentry: 'DiagnosticHydraulicTemperatureSensors',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitPumpDeltaTemperatureValue',
              isRead: 'true',
              interval: '2761',
              texttableentry: 'PrimaryCircuitPumpDeltaTemperatureValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressureDrop',
              isRead: 'true',
              interval: '2767',
              texttableentry: 'DiagnosticMonitoringPressureDrop',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressurePeaks',
              isRead: 'true',
              interval: '2768',
              texttableentry: 'DiagnosticMonitoringPressurePeaks',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrixTwo',
              isRead: 'true',
              interval: '2776',
              texttableentry: 'ProductMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryBootLoaderVersion',
              isRead: 'true',
              interval: '2777',
              texttableentry: 'PrimaryBootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryHeatExchangerVaporPressureSensor',
              isRead: 'true',
              interval: '2784',
              texttableentry: 'SecondaryHeatExchangerVaporPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpStatus',
              isRead: 'true',
              interval: '2791',
              texttableentry: 'CentralHeatingPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpStatus',
              isRead: 'true',
              interval: '2792',
              texttableentry: 'MixerOneCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpStatus',
              isRead: 'true',
              interval: '2793',
              texttableentry: 'MixerTwoCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpStatus',
              isRead: 'true',
              interval: '2794',
              texttableentry: 'MixerThreeCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpStatus',
              isRead: 'true',
              interval: '2795',
              texttableentry: 'MixerFourCircuitPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterConfiguration',
              isRead: 'true',
              interval: '2796',
              texttableentry: 'ExternalHeaterConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RefrigerationCircuitOperationMode',
              isRead: 'true',
              interval: '2806',
              texttableentry: 'RefrigerationCircuitOperationMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterHousingTemperature',
              isRead: 'true',
              interval: '2807',
              texttableentry: 'InverterHousingTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterInternalPowerModuleTemperature',
              isRead: 'true',
              interval: '2808',
              texttableentry: 'InverterInternalPowerModuleTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductIdentification',
              isRead: 'true',
              interval: '2829',
              texttableentry: 'ProductIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BivalenceControlAlternativeTemperature',
              isRead: 'true',
              interval: '2831',
              texttableentry: 'BivalenceControlAlternativeTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTimeIntegralThershold',
              isRead: 'true',
              interval: '2853',
              texttableentry: 'ExternalHeaterTimeIntegralThershold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2855',
              texttableentry: 'MixerOneCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2856',
              texttableentry: 'MixerTwoCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2857',
              texttableentry: 'MixerThreeCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2858',
              texttableentry: 'MixerFourCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2859',
              texttableentry: 'MixerFiveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2860',
              texttableentry: 'MixerSixCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2861',
              texttableentry: 'MixerSevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2862',
              texttableentry: 'MixerEightCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2863',
              texttableentry: 'MixerNineCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2864',
              texttableentry: 'MixerTenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2865',
              texttableentry: 'MixerElevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2866',
              texttableentry: 'MixerTwelveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2867',
              texttableentry: 'MixerThirteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2868',
              texttableentry: 'MixerFourteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2869',
              texttableentry: 'MixerFifteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2870',
              texttableentry: 'MixerSixteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitHeatingBlocked',
              isRead: 'true',
              interval: '2879',
              texttableentry: 'MixerOneCircuitHeatingBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitHeatingBlocked',
              isRead: 'true',
              interval: '2880',
              texttableentry: 'MixerTwoCircuitHeatingBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCycleAvailability',
              isRead: 'true',
              interval: '2894',
              texttableentry: 'RefrigerantCycleAvailability',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterSpecification',
              isRead: 'true',
              interval: '2920',
              texttableentry: 'ExternalHeaterSpecification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterIntervalSettings',
              isRead: 'true',
              interval: '2921',
              texttableentry: 'DiagnosticHydraulicFilterIntervalSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterIntervalTemporalSettings',
              isRead: 'true',
              interval: '2922',
              texttableentry: 'DiagnosticHydraulicFilterIntervalTemporalSettings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticSecondaryFourThreeWayValveSettings',
              isRead: 'true',
              interval: '2923',
              texttableentry: 'DiagnosticSecondaryFourThreeWayValveSettings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticHydraulicFilterContaminationSettings',
              isRead: 'true',
              interval: '2924',
              texttableentry: 'DiagnosticHydraulicFilterContaminationSettings',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressurePeaksSettings',
              isRead: 'true',
              interval: '2925',
              texttableentry: 'DiagnosticMonitoringPressurePeaksSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticMonitoringPressureDropSettings',
              isRead: 'true',
              interval: '2926',
              texttableentry: 'DiagnosticMonitoringPressureDropSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeCounterSinceLastReset',
              isRead: 'true',
              interval: '2932',
              texttableentry: 'TimeCounterSinceLastReset',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentElectricalSystemPowerSetpoint',
              isRead: 'true',
              interval: '2934',
              texttableentry: 'CurrentElectricalSystemPowerSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CurrentSystemState',
              isRead: 'true',
              interval: '2935',
              texttableentry: 'CurrentSystemState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterDelayTimer',
              isRead: 'true',
              interval: '2940',
              texttableentry: 'ExternalHeaterDelayTimer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevices',
              isRead: 'true',
              interval: '2942',
              texttableentry: 'ListOfLayerSettingServiceDevices',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSystemDeviceList',
              isRead: 'true',
              interval: '2943',
              texttableentry: 'ResetSystemDeviceList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NodeIdOnExternalCan',
              isRead: 'true',
              interval: '2944',
              texttableentry: 'NodeIdOnExternalCan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevicesTwo',
              isRead: 'true',
              interval: '2952',
              texttableentry: 'ListOfLayerSettingServiceDevicesTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfigurationArray',
              isRead: 'true',
              interval: '2953',
              texttableentry: 'CascadeSystemConfigurationArray',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTemperatureSetpoint',
              isRead: 'true',
              interval: '2985',
              texttableentry: 'ExternalHeaterTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterOperationState',
              isRead: 'true',
              interval: '2986',
              texttableentry: 'ExternalHeaterOperationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EcuResetInformationList',
              isRead: 'true',
              interval: '3000',
              texttableentry: 'EcuResetInformationList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerHybridThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '3013',
              texttableentry: 'MixerHybridThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutdoorMiddleCoilTemperatureSensor',
              isRead: 'true',
              interval: '3014',
              texttableentry: 'OutdoorMiddleCoilTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '3015',
              texttableentry: 'HeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3016',
              texttableentry: 'HeatingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CoolingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3017',
              texttableentry: 'CoolingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingCoolingBufferTemperatureSensor',
              isRead: 'true',
              interval: '3018',
              texttableentry: 'HeatingCoolingBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterEfficiencyMode',
              isRead: 'true',
              interval: '3029',
              texttableentry: 'DomesticHotWaterEfficiencyMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterEfficiencyModeAvailability',
              isRead: 'true',
              interval: '3030',
              texttableentry: 'DomesticHotWaterEfficiencyModeAvailability',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeater',
              isRead: 'true',
              interval: '3031',
              texttableentry: 'ExternalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryEnergyFactorElectricity',
              isRead: 'true',
              interval: '3032',
              texttableentry: 'PrimaryEnergyFactorElectricity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterReturnTemperaturTankLoadSystem',
              isRead: 'true',
              interval: '3034',
              texttableentry: 'DomesticHotWaterReturnTemperaturTankLoadSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowTemperaturTankLoadSystem',
              isRead: 'true',
              interval: '3035',
              texttableentry: 'DomesticHotWaterFlowTemperaturTankLoadSystem',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryEnergyFactorExternalHeater',
              isRead: 'true',
              interval: '3036',
              texttableentry: 'PrimaryEnergyFactorExternalHeater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleMonday',
              isRead: 'true',
              interval: '3037',
              texttableentry: 'ElectricityPriceTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleTuesday',
              isRead: 'true',
              interval: '3038',
              texttableentry: 'ElectricityPriceTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleWednesday',
              isRead: 'true',
              interval: '3039',
              texttableentry: 'ElectricityPriceTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleThursday',
              isRead: 'true',
              interval: '3040',
              texttableentry: 'ElectricityPriceTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleFriday',
              isRead: 'true',
              interval: '3041',
              texttableentry: 'ElectricityPriceTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleSaturday',
              isRead: 'true',
              interval: '3042',
              texttableentry: 'ElectricityPriceTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPriceTimeScheduleSunday',
              isRead: 'true',
              interval: '3043',
              texttableentry: 'ElectricityPriceTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterHighDemandDetection',
              isRead: 'true',
              interval: '3066',
              texttableentry: 'DomesticHotWaterHighDemandDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointComfort',
              isRead: 'true',
              interval: '3068',
              texttableentry: 'DomesticHotWaterTemperatureSetpointComfort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSensorForDemand',
              isRead: 'true',
              interval: '3069',
              texttableentry: 'DomesticHotWaterSensorForDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferTargetOperationMode',
              isRead: 'true',
              interval: '3070',
              texttableentry: 'BufferTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterTemperatureOffset',
              isRead: 'true',
              interval: '3098',
              texttableentry: 'ExternalHeaterTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferMinimumMaximumSetTemperature',
              isRead: 'true',
              interval: '3106',
              texttableentry: 'BufferMinimumMaximumSetTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerBaseHeaterStatistical',
              isRead: 'true',
              interval: '3109',
              texttableentry: 'PrimaryHeatExchangerBaseHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignalStatistical',
              isRead: 'true',
              interval: '3110',
              texttableentry: 'ExternalFaultSignalStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarCollectorFrostprotectionStatistical',
              isRead: 'true',
              interval: '3111',
              texttableentry: 'SolarCollectorFrostprotectionStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccentLedBarStatistical',
              isRead: 'true',
              interval: '3112',
              texttableentry: 'AccentLedBarStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValueStatistical',
              isRead: 'true',
              interval: '3113',
              texttableentry: 'DeviceDigitalOutputOneValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValueStatistical',
              isRead: 'true',
              interval: '3114',
              texttableentry: 'DeviceDigitalOutputTwoValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValueStatistical',
              isRead: 'true',
              interval: '3115',
              texttableentry: 'DeviceDigitalOutputThreeValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFourValueStatistical',
              isRead: 'true',
              interval: '3116',
              texttableentry: 'DeviceDigitalOutputFourValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFiveValueStatistical',
              isRead: 'true',
              interval: '3117',
              texttableentry: 'DeviceDigitalOutputFiveValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSixValueStatistical',
              isRead: 'true',
              interval: '3118',
              texttableentry: 'DeviceDigitalOutputSixValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RefrigerantCircuitFourWayValveStatistical',
              isRead: 'true',
              interval: '3119',
              texttableentry: 'RefrigerantCircuitFourWayValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CompressorCrankCaseHeaterStatistical',
              isRead: 'true',
              interval: '3120',
              texttableentry: 'CompressorCrankCaseHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnhancedVapourInjectionValveStatistical',
              isRead: 'true',
              interval: '3121',
              texttableentry: 'EnhancedVapourInjectionValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridLockStatistical',
              isRead: 'true',
              interval: '3122',
              texttableentry: 'EnableElectricalHeaterSmartGridLockStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnableElectricalHeaterSmartGridIncreaseMaxDemandStatistical',
              isRead: 'true',
              interval: '3123',
              texttableentry: 'EnableElectricalHeaterSmartGridIncreaseMaxDemandStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSevenValueStatistical',
              isRead: 'true',
              interval: '3124',
              texttableentry: 'DeviceDigitalOutputSevenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputEightValueStatistical',
              isRead: 'true',
              interval: '3125',
              texttableentry: 'DeviceDigitalOutputEightValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputNineValueStatistical',
              isRead: 'true',
              interval: '3126',
              texttableentry: 'DeviceDigitalOutputNineValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTenValueStatistical',
              isRead: 'true',
              interval: '3127',
              texttableentry: 'DeviceDigitalOutputTenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputElevenValueStatistical',
              isRead: 'true',
              interval: '3128',
              texttableentry: 'DeviceDigitalOutputElevenValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanDuctHeaterStatistical',
              isRead: 'true',
              interval: '3129',
              texttableentry: 'FanDuctHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FanStatistical',
              isRead: 'true',
              interval: '3131',
              texttableentry: 'FanStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpStatistical',
              isRead: 'true',
              interval: '3134',
              texttableentry: 'DomesticHotWaterCirculationPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryCentralHeatingPumpStatistical',
              isRead: 'true',
              interval: '3139',
              texttableentry: 'SecondaryCentralHeatingPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DigitalOutputCoolingStatistical',
              isRead: 'true',
              interval: '3144',
              texttableentry: 'DigitalOutputCoolingStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalHeaterStatistical',
              isRead: 'true',
              interval: '3145',
              texttableentry: 'ExternalHeaterStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseOneStatistical',
              isRead: 'true',
              interval: '3146',
              texttableentry: 'ElectricalHeaterPhaseOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseTwoStatistical',
              isRead: 'true',
              interval: '3147',
              texttableentry: 'ElectricalHeaterPhaseTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalHeaterPhaseThreeStatistical',
              isRead: 'true',
              interval: '3148',
              texttableentry: 'ElectricalHeaterPhaseThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpStatus',
              isRead: 'true',
              interval: '3155',
              texttableentry: 'DomesticHotWaterShiftLoadPumpStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPumpType',
              isRead: 'true',
              interval: '3156',
              texttableentry: 'DomesticHotWaterShiftLoadPumpType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TelemetryControlUnitTargetOperationMode',
              isRead: 'true',
              interval: '3188',
              texttableentry: 'TelemetryControlUnitTargetOperationMode',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
